import { render } from "./ArticleIndexPage.vue?vue&type=template&id=e0e89e34"
import script from "./ArticleIndexPage.vue?vue&type=script&lang=js"
export * from "./ArticleIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__